<template>
  <div class="carousel-container">
    <el-carousel class="d-none d-lg-block d-xl-block" style="height: 600px">
      <el-carousel-item
        v-for="item in pcLists"
        :key="item.title"
        style="height: 622px"
      >
        <el-image style="width: 100%; height: 622px" :src="item.imgUrl" />
        <div class="carousel-captions">
          <h2>{{ item.title }}</h2>
          <p>{{ item.desc }}</p>
          <img src="@/assets/images/lunbo/btn.png" mode="" />
        </div>
      </el-carousel-item>
    </el-carousel>
    <el-carousel class="d-sm-block d-md-block d-xl-none d-lg-none">
      <el-carousel-item v-for="item in h5Lists" :key="item.title">
        <el-image style="width: 100%" :src="item.imgUrl" />
        <div class="carousel-captions">
          <h2>{{ item.title }}</h2>
          <p>{{ item.desc }}</p>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import { reactive } from "vue";
export default {
  name: "CarouSel",
  setup() {
    const pcLists = reactive([
      {
        title: "训练+推理的训推一体方案",
        desc: "区域分级管理｜实时预警定位｜高效 AI 算力调度｜多系统快速集成",
        imgUrl: require("@/assets/images/lunbo/bg01.png"),
      },
    ]);
    const h5Lists = reactive([
      {
        title: "",
        desc: "",
        imgUrl: require("@/assets/images/main/h5-lunbo.png"),
      },
    ]);

    return { pcLists, h5Lists };
  },
};
</script>

<style lang="scss" scoped>
.carousel-captions {
  position: absolute;
  top: 160px;
  left: 260px;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  h2 {
    width: 650px;
    height: 67px;
    font-family:
      Microsoft YaHei UI,
      Microsoft YaHei UI;
    font-weight: 600;
    font-size: 50px;
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  p {
    margin-top: 28px;
    width: 500px;
    height: 52px;
    font-family:
      Microsoft YaHei,
      Microsoft YaHei;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    line-height: 26px;
    letter-spacing: 1px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  img {
    margin-top: 35px;
    width: 198px;
    height: 64px;
  }
}

@media screen and (max-width: 768px) {
  #carouselExampleDark {
    .carousel-inner {
      width: 100%;
      height: 544px;
      background-color: #0d0f30;
      overflow: hidden;
      .carousel-item {
        height: 100%;
        display: flex;
        align-items: center;
        background: url("@/assets/images/lunbo/bg01.png") left -27.33333vw top
          0/154.66667vw 53.6vw no-repeat;
        img {
          width: 88vw;
          height: 80vw;
        }
        .carousel-captions {
          width: 100%;
          left: 0;
          right: 0;
          h2 {
            font-size: 30px;
          }
          p {
            margin-top: 300px;
          }
        }
      }
    }
  }
}
</style>
